import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { SocketContext } from "./ConnectorSocket";

// Хук для подписки на события сокета
// Используется для подписки на события сокета и вызова обработчика при получении сообщения
export default function useOn(event, handler) {
    const { socket } = useContext(SocketContext);
    const handlerRef = useRef(null);
  
    useEffect(() => {
      handlerRef.current = handler;
    }, [handler]);
  
    useEffect(() => {
      if (socket) {
        const eventListener = (msg) => {
          if (handlerRef.current) {
            handlerRef.current(msg);
          }
        };
  
        socket.on(event, eventListener);
        return () => {
          socket.off(event, eventListener);
        };
      }
    }, [event, socket]);
  }